/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  CreateWorkflowRequestBody,
  CreateWorkflowResponse,
  GetWorkflowResponse,
  GetWorkflowsParams,
  GetWorkflowsResponse,
  UpdateWorkflowRequestBody,
  UpdateWorkflowResponse
} from '../model';

import postWorkflowMutator from '../../../mutators/datastore-instance';
import getWorkflowsMutator from '../../../mutators/datastore-instance';
import putWorkflowMutator from '../../../mutators/datastore-instance';
import getWorkflowMutator from '../../../mutators/datastore-instance';
import deleteWorkflowMutator from '../../../mutators/datastore-instance';



  /**
 * Workflowを新規作成する
 * @summary Workflowを新規作成
 */
export const postWorkflow = (
    createWorkflowRequestBody?: CreateWorkflowRequestBody,
 ) => {
      return postWorkflowMutator<CreateWorkflowResponse>(
      {url: `/workflows`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorkflowRequestBody
    },
      );
    }
  /**
 * Workflowの一覧を取得する
 * @summary Workflowの一覧取得
 */
export const getWorkflows = (
    params?: GetWorkflowsParams,
 ) => {
      return getWorkflowsMutator<GetWorkflowsResponse>(
      {url: `/workflows`, method: 'GET',
        params
    },
      );
    }
  /**
 * Workflowを更新する
 * @summary Workflowを更新
 */
export const putWorkflow = (
    workflowId: number,
    updateWorkflowRequestBody?: UpdateWorkflowRequestBody,
 ) => {
      return putWorkflowMutator<UpdateWorkflowResponse>(
      {url: `/workflows/${workflowId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkflowRequestBody
    },
      );
    }
  /**
 * Workflowの詳細を取得する
 * @summary Workflowの詳細取得
 */
export const getWorkflow = (
    workflowId: number,
 ) => {
      return getWorkflowMutator<GetWorkflowResponse>(
      {url: `/workflows/${workflowId}`, method: 'GET'
    },
      );
    }
  /**
 * Workflowを削除する
 * @summary workflowの削除
 */
export const deleteWorkflow = (
    workflowId: number,
 ) => {
      return deleteWorkflowMutator<void>(
      {url: `/workflows/${workflowId}`, method: 'DELETE'
    },
      );
    }
  export type PostWorkflowResult = NonNullable<Awaited<ReturnType<typeof postWorkflow>>>
export type GetWorkflowsResult = NonNullable<Awaited<ReturnType<typeof getWorkflows>>>
export type PutWorkflowResult = NonNullable<Awaited<ReturnType<typeof putWorkflow>>>
export type GetWorkflowResult = NonNullable<Awaited<ReturnType<typeof getWorkflow>>>
export type DeleteWorkflowResult = NonNullable<Awaited<ReturnType<typeof deleteWorkflow>>>
